import { Pencil } from 'lucide-react';

export interface InlineEditButtonProps {
  /** Opens the quick-edit view for the already-selected entity. */
  onClick: () => void;
  /** Accessible label + tooltip, e.g. "Edit vendor". */
  label: string;
  /** Optional visible text next to the pencil icon (e.g. "Edit"). */
  text?: string;
  className?: string;
}

/**
 * Small inline "edit" affordance shown next to an already-selected entity
 * (vendor, catalog item, …). Selecting an entity from a dropdown should never
 * pop its edit modal — this button is the deliberate, on-demand way to open the
 * quick-edit view for the current selection.
 */
export function InlineEditButton({ onClick, label, text, className }: InlineEditButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className={`inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-800 ${
        className ?? ''
      }`}
    >
      <Pencil size={12} className="shrink-0" />
      {text && <span>{text}</span>}
    </button>
  );
}
